import type { TPermissionsMap } from "../types";
import type { ApiClient } from "./client";

export class PermissionsApi {
  constructor(private apiClient: ApiClient) {}

  async getPermissions(): Promise<TPermissionsMap> {
    const response = await this.apiClient.get<TPermissionsMap>(
      "/role-and-permissions",
    );
    return response.data;
  }
}
